import React from "react";

// Placeholder imports - update with actual course capability videos
import ModelingVideo from "../../assets/staad-pro/video/RCDesignDetailing.mp4";
import AnimationVideo from "../../assets/staad-pro/video/3DStructuralModeling.mp4";
import ProceduralVideo from "../../assets/staad-pro/video/LoadCasesCombinations.mp4";
import AddOnVideo from "../../assets/staad-pro/video/SteelMemberDesign.mp4";


//! sewergems

import SanitarySewerModeling from "../../assets/sewergems/video/SanitarySewerModeling.mp4";
import StormwaterDetentionDesign from "../../assets/sewergems/video/StormwaterDetentionDesign.mp4";
import CombinedSewerOverflowAnalysis from "../../assets/sewergems/video/CombinedSewerOverflowAnalysis.mp4";
import PumpStationOperationsOptimization from "../../assets/sewergems/video/PumpStationOperationsOptimization.mp4";

//!microstation
import MicrostationModelingVideo from "../../assets/microstation/video/Precision2DDrafting.mp4";
import MicrostationAnimationVideo from "../../assets/microstation/video/Precision2DDrafting.mp4";
import MicrostationProceduralVideo from "../../assets/microstation/video/BIMWorkflowsIFCData.mp4";
import MicrostationAddOnVideo from "../../assets/microstation/video/VisualizationRendering.mp4";

//!openroads-designer
// import ModelingVideo from "../../assets/openroads-designer/video/SurveyTerrainModeling.mp4";
// import AnimationVideo from "../../assets/openroads-designer/video/HorizontalVerticalAlignments.mp4";
// import ProceduralVideo from "../../assets/openroads-designer/video/DrainageUtilityCoordination.mp4";
// import AddOnVideo from "../../assets/openroads-designer/video/QuantitiesConstructionDocumentation.mp4";



const CourseVideoCards = ({ courseId }) => {

const courseVideoData = {
    'openroads-designer': {
        cards: [
            {
                title: "Survey & Terrain Modeling",
                description: "Import survey points, GPS, LiDAR, and total station data to build precise existing-ground terrain models as the foundation for roadway design.",
                video: ModelingVideo,
            },
            {
                title: "Horizontal & Vertical Alignments",
                description: "Design road centerlines and profiles using dynamic alignment tools, then build 3D corridors with template-driven cross-sections.",
                video: AnimationVideo,
            },
            {
                title: "Drainage & Utility Coordination",
                description: "Model culverts, storm networks, and underground utilities alongside the corridor to catch conflicts before construction.",
                video: ProceduralVideo,
            },
            {
                title: "Quantities & Construction Documentation",
                description: "Generate earthwork volumes, cross-section sheets, and construction-ready plan sets directly from the 3D corridor model.",
                video: AddOnVideo,
            },
        ]
    },
    'watergems': {
        cards: [
            {
                title: "Water Network Modeling",
                description: "Build hydraulic models of pipes, junctions, pumps, tanks, and valves from GIS or CAD data to represent an entire distribution system.",
                video: ModelingVideo,
            },
            {
                title: "Demand Allocation & Pipe Sizing",
                description: "Assign residential, commercial, and industrial demand patterns and size pipes to meet pressure and flow targets across the network.",
                video: AnimationVideo,
            },
            {
                title: "Extended Period Simulation (EPS)",
                description: "Run time-varying simulations to study pump scheduling, tank draw-down, and system response over a 24-hour or multi-day period.",
                video: ProceduralVideo,
            },
            {
                title: "Fire Flow & Criticality Analysis",
                description: "Test the network against fire-flow demand scenarios and identify critical pipes whose failure would most impact service.",
                video: AddOnVideo,
            },
        ]
    },
    'staad-pro': {
        cards: [
            {
                title: "3D Structural Modeling",
                description: "Build frame, plate, and solid element models with defined geometry, member properties, materials, and boundary conditions.",
                video: ModelingVideo,
            },
            {
                title: "Load Cases & Combinations",
                description: "Apply dead, live, wind, seismic, and thermal loads and generate code-based load combinations for full structural analysis.",
                video: AnimationVideo,
            },
            {
                title: "Steel Member Design",
                description: "Check and design steel members against international codes such as AISC, Eurocode, and IS 800 directly from analysis results.",
                video: ProceduralVideo,
            },
            {
                title: "RC Design & Detailing",
                description: "Design reinforced concrete beams, columns, slabs, and footings, with reinforcement detailing output for construction drawings.",
                video: AddOnVideo,
            },
        ]
    },
    'microstation': {
        cards: [
            {
                title: "Precision 2D Drafting",
                description: "Produce accurate 2D drawings using precision input, dimensioning, cells, and annotation tools built for engineering documentation.",
                video: MicrostationModelingVideo,
            },
            {
                title: "3D Solid & Surface Modeling",
                description: "Construct 3D models using solid modeling, surface modeling, and parametric tools shared across Bentley's design applications.",
                video: MicrostationAnimationVideo,
            },
            {
                title: "BIM Workflows & IFC Data",
                description: "Coordinate multi-discipline models through IFC import/export, reference attachments, and clash-aware model review.",
                video: MicrostationProceduralVideo,
            },
            {
                title: "Visualization & Rendering",
                description: "Apply materials, lighting, and Luxology-based rendering to produce presentation-quality visualizations from the design model.",
                video: MicrostationAddOnVideo,
            },
        ]
    },
    'sewergems': {
        cards: [
            {
                title: "Sanitary Sewer Modeling",
                description: "Build gravity and force-main sanitary networks from GIS or survey data and evaluate capacity against peak wastewater flows.",
                video: SanitarySewerModeling,
            },
            {
                title: "Stormwater & Detention Design",
                description: "Model storm networks, channels, and detention/retention facilities to manage runoff under design storm events.",
                video: StormwaterDetentionDesign,
            },
            {
                title: "Combined Sewer Overflow Analysis",
                description: "Analyze combined sewer systems for overflow behavior and design diversion structures to control wet-weather discharge.",
                video: CombinedSewerOverflowAnalysis,
            },
            {
                title: "Pump Station & Operations Optimization",
                description: "Model pump station performance and test operational scenarios to improve energy efficiency and system reliability.",
                video: PumpStationOperationsOptimization,
            },
        ]
    }
};

    const cards = courseVideoData[courseId]?.cards || [];

    if (cards.length === 0) {
        return null;
    }

    return (
        <section className="course-video-cards">

            <div className="course-video-cards-container">

                <h2 className="course-video-cards-title">
                    Explore Course Capabilities
                </h2>

                <div className="course-video-grid">

                    {cards.map((card, index) => (

                        <article
                            className="course-video-card"
                            key={index}
                        >

                            {/* VIDEO */}
                            <div className="course-card-video-wrapper">

                                <video
                                    className="course-card-video"
                                    src={card.video}
                                    autoPlay
                                    muted
                                    loop
                                    playsInline
                                    preload="auto"
                                />

                            </div>


                            {/* CONTENT */}
                            <div className="course-card-content">

                                <h3>
                                    {card.title}
                                </h3>

                                <p>
                                    {card.description}
                                </p>

                            </div>

                        </article>

                    ))}

                </div>

            </div>


            <style>{`

                .course-video-cards {
                    width: 100%;
                    background: #ffffff;
                    padding: 70px 40px 90px;
                    box-sizing: border-box;
                }


                .course-video-cards-container {
                    width: 100%;
                    max-width: 1400px;
                    margin: 0 auto;
                }


                .course-video-cards-title {
                    margin: 0 0 55px;

                    font-family: 'Plus Jakarta Sans', sans-serif;

                    font-size: 36px;

                    font-weight: 600;

                    line-height: 1.2;

                    letter-spacing: -1.5px;

                    color: #000000;
                }


                .course-video-grid {
                    display: grid;

                    grid-template-columns:
                        repeat(4, minmax(0, 1fr));

                    gap: 28px;
                }


                .course-video-card {
                    background: #f8f9fa;

                    border: 1px solid #e1e4e7;

                    border-radius: 20px;

                    overflow: hidden;

                    display: flex;

                    flex-direction: column;

                    min-width: 0;

                    transition:
                        transform 0.3s ease,
                        box-shadow 0.3s ease;
                }


                .course-video-card:hover {
                    transform: translateY(-5px);

                    box-shadow:
                        0 15px 35px
                        rgba(0, 0, 0, 0.08);
                }


                /* VIDEO */

                .course-card-video-wrapper {
                    width: 100%;

                    height: 230px;

                    overflow: hidden;

                    background: #111111;
                }


                .course-card-video {
                    display: block;

                    width: 100%;

                    height: 100%;

                    object-fit: cover;
                }


                /* CONTENT */

                .course-card-content {
                    padding: 30px 32px 34px;

                    display: flex;

                    flex-direction: column;

                    flex: 1;
                }


                .course-card-content h3 {
                    margin: 0 0 14px;

                    font-family:
                        'Plus Jakarta Sans',
                        sans-serif;

                    font-size: 18px;

                    font-weight: 600;

                    line-height: 1.3;

                    color: #111111;
                }


                .course-card-content p {
                    margin: 0;

                    font-family:
                        'Plus Jakarta Sans',
                        sans-serif;

                    font-size: 15px;

                    font-weight: 400;

                    line-height: 1.65;

                    color: #6b7280;

                    text-align: left;
                }


                /* TABLET */

                @media (max-width: 1200px) {

                    .course-video-grid {
                        grid-template-columns:
                            repeat(2, 1fr);
                    }

                }


                /* MOBILE */

                @media (max-width: 650px) {

                    .course-video-cards {
                        padding:
                            50px 20px 60px;
                    }


                    .course-video-cards-title {
                        font-size: 36px;

                        margin-bottom: 35px;
                    }


                    .course-video-grid {
                        grid-template-columns: 1fr;

                        gap: 24px;
                    }


                    .course-card-video-wrapper {
                        height: 240px;
                    }

                }

            `}</style>

        </section>
    );
};

export default CourseVideoCards;
